import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { Link } from "gatsby";

function Whychoosespeeech() {
  return (
    <section className="voice_services why_choose_speech p-100">
      <Container>
        <Row>
          <Col
            xs={12}
            md={9}
            lg={8}
            xl={8}
            xxl={8}
            className="m-auto text-center"
          >
            <h2>Our Proven Approach to Fintech Software Development</h2>
            <p>
              As a leading fintech software development company, TekRevol
              follows a structured approach that prioritizes quality
              transparency and allows us to make the best of our processes to
              deliver solutions within budget and time.
            </p>
          </Col>
        </Row>
        <Row className="mt-sm-3 mt-md-4">
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <Row>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head">
                      <h5>Initial Consultation and Requirement Gathering</h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our team of experts engages in detailed discussions to
                      understand your business goals, target audience,
                      challenges, and desired functionalities for the FinTech
                      solution.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head">
                      <h5>
                        Solution Design and
                        <br className="d-none d-xl-block" /> Prototyping
                      </h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We generate and present multiple solution concepts that
                      align with your goals and budget, ensuring we meet your
                      unique needs effectively.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head">
                      <h5>
                        Agile Development and{" "}
                        <br className="d-none d-xl-block" /> Testing
                      </h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our experts employ an agile methodology, breaking down the
                      project into manageable sprints and incorporating feedback
                      at each stage for optimal results.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head">
                      <h5>
                        Deployment and <br className="d-none d-xl-block" />{" "}
                        Launch
                      </h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We prepare for deployment in your chosen environment to
                      ensure a smooth launch with minimal disruption and work
                      closely with you throughout the process.
                    </p>
                  </div>
                </div>
              </Col>

              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head">
                      <h5>
                        Post-Launch Support and{" "}
                        <br className="d-none d-xl-block" /> Maintenance
                      </h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      Our team provides continuous technical support to address
                      post-deployment issues and ensure optimal functionality of
                      your fintech solution.
                    </p>
                  </div>
                </div>
              </Col>
              <Col xs={12} md={6} lg={4} xl={4} xxl={4}>
                <div className="voice_service_box">
                  <div className="voice_service_main">
                    <div className="voice_service_head">
                      <h5>
                        Performance Analysis and{" "}
                        <br className="d-none d-xl-block" /> Optimization
                      </h5>
                    </div>
                  </div>
                  <div className="voice_service_content">
                    <p>
                      We gather user feedback and data for performance analysis,
                      identifying areas for enhancement and collaborating with
                      you to implement updates for an improved experience.
                    </p>
                  </div>
                </div>
              </Col>
            </Row>
          </Col>
        </Row>
        {/* <Row>
          <Col
            xs={12}
            md={6}
            lg={6}
            xl={6}
            xxl={6}
            className="m-auto text-center mt-sm-3 mt-md-5"
          >
            <Link
              to="/contact"
              className="border_btn"
              aria-label="TekRevol Contact"
            >
              Book Your Consultation Today!
            </Link>
          </Col>
        </Row> */}
      </Container>
    </section>
  );
}

export default Whychoosespeeech;
